import legacyThemeRepository from '@/shared/api/legacyThemeRepository';

export default {
  data: () => ({ themeChanging: false }),
  methods: {
    async changeInterfacePlatinum() {
      if (this.themeChanging) return;
      this.themeChanging = true;
      try {
        const dark = await legacyThemeRepository.toggle();
        this.$store.commit('toggleDarkTheme', dark);
        try { localStorage.setItem('dark_theme', String(dark)); } catch (_) { /* Storage can be unavailable. */ }
        document.body.style.backgroundColor = dark ? '#0F0F1A' : '#FFFFFF';
      } catch (_) {
        this.$vueOnToast.pop('error', 'No se pudo cambiar el tema. Inténtalo de nuevo.');
      } finally {
        this.themeChanging = false;
      }
    }
  }
};
